import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { buildRootReducer } from '@olxbr/mojo-jojo/reducers';

import rootReducer from './core/reducers';

const { NODE_ENV } = process.env;

const store = createStore(
  buildRootReducer({ ui: rootReducer }),
  compose(
    applyMiddleware(thunk),
    (NODE_ENV === 'development' && window.__REDUX_DEVTOOLS_EXTENSION__) ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f,
  ),
);

export default store;
